export const AnvilActionTypes = {
    API_RESPONSE_SUCCESS: '@@anvil/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@anvil/API_RESPONSE_ERROR',
    REVIEW_PDF: '@@anvil/REVIEW_PDF',
    SIGN_ETCH_PACKET: '@@anvil/SIGN_ETCH_PACKET',
    RESET_ANVIL: '@@anvil/RESET_ANVIL',
};
